import { Textarea } from "@/components/ui/textarea";
import { useFieldContext } from "@/features/question/components/organisms/FieldRenderer";
import { useState, useEffect } from "react";

export function TextareaRenderer() {
    const { question, setFormValue, disabled, response, currentValue } = useFieldContext();
    const [value, setValue] = useState<string>("");
    const {field_max: max_length} = question;
    const {field_min: min_length} = question;

    useEffect(() => {
        if(currentValue) {
            setValue(currentValue);
        }
    }, [currentValue]);

    if (disabled) {
        return (
            <div className="">
                <pre>{response.field_value}</pre>
            </div>
        )
    } else {
        return (
            <div className="flex flex-col gap-2">
                <Textarea
                    onChange={(e) => {
                        const value = e.target.value;
                        setValue(value);
                        setFormValue(value);
                    }}
                    minLength={min_length ?? undefined}
                    maxLength={max_length ?? undefined}
                    rows={4}
                    value={value}
                />
                {max_length && <p className="[font-size:12px]">{value.split('').length}/{max_length}</p>}
                
            </div>
        )
    }

}
